namespace TabAurous.HR {
    export interface LeaveTypeRow {
        LeaveTypeId?: number;
        LeaveTypeCode?: string;
        MaxLeavesAllowed?: number;
        ApplicableAfter?: number;
        MaxContinuosDays?: number;
        IsCarryForward?: boolean;
        IsLeaveWithoutPay?: boolean;
        IsOptional?: boolean;
        AllowNegativeBalance?: boolean;
        Includeholidayswithinleavesasleaves?: boolean;
        IsCompensatory?: boolean;
        IsPartiallyPaidLeaves?: boolean;
        FractionofDailySalaryPerLeave?: number;
        AllowEncashment?: boolean;
        MaxEncashmentDays?: number;
        EncashmentComponentId?: number;
    }

    export namespace LeaveTypeRow {
        export const idProperty = 'LeaveTypeId';
        export const nameProperty = 'LeaveTypeCode';
        export const localTextPrefix = 'HR.LeaveType';
        export const deletePermission = 'HR:LeaveType:Delete';
        export const insertPermission = 'HR:LeaveType:Add';
        export const readPermission = '*';
        export const updatePermission = 'HR:LeaveType:Edit';

        export declare const enum Fields {
            LeaveTypeId = "LeaveTypeId",
            LeaveTypeCode = "LeaveTypeCode",
            MaxLeavesAllowed = "MaxLeavesAllowed",
            ApplicableAfter = "ApplicableAfter",
            MaxContinuosDays = "MaxContinuosDays",
            IsCarryForward = "IsCarryForward",
            IsLeaveWithoutPay = "IsLeaveWithoutPay",
            IsOptional = "IsOptional",
            AllowNegativeBalance = "AllowNegativeBalance",
            Includeholidayswithinleavesasleaves = "Includeholidayswithinleavesasleaves",
            IsCompensatory = "IsCompensatory",
            IsPartiallyPaidLeaves = "IsPartiallyPaidLeaves",
            FractionofDailySalaryPerLeave = "FractionofDailySalaryPerLeave",
            AllowEncashment = "AllowEncashment",
            MaxEncashmentDays = "MaxEncashmentDays",
            EncashmentComponentId = "EncashmentComponentId"
        }
    }
}
